import React from 'react';
import { Link } from 'react-router-dom';
//import { Modal, Button } from "react-bootstrap";

function AdminDashboard() {

    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    return (
        <div>
            <div className="int-container">
                <div class="container">
                    <div class="form-container-large" style={{ padding: "100px 30px" }}>
                        <div class="row">
                            <div class="form-group">
                                <div className="col-md-8">
                                    <h2 style={{ color: "#fff", width: "100%", marginTop: '20px' }}>Welcome</h2>
                                    <h2 style={{ color: "#f19f1f", width: "100%" }}>Admin</h2>
                                </div>                                
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group" style={{ marginTop: '50px', paddingLeft: '15px' }}>                                
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/admin/manage-members">Members</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/admin/calls-report">Calls</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <Link className="btn btn-primary" style={{ lineHeight: "0" }} to="/admin/transactions-report">Transactions</Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <a className="btn btn-primary" style={{ lineHeight: "0" }} target="_blank" href="http://pethelp911.com/cms/">CMS</a>                                
                            
                                {/* <Button variant="primary" onClick={handleShow}>Open Link</Button>



<Modal show={show} onHide={handleClose}>
  <Modal.Title>Link Popup</Modal.Title>
<Modal.Body><iframe src='http://pethelp911.com/cms/' style={{width:'100%',height:'400px'}}/></Modal.Body>
<Modal.Footer>
  <Button variant="secondary" onClick={handleClose}>
    Close
  </Button>
</Modal.Footer>
</Modal> */}

{/* <button type="button" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal">Open Modal</button>


<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">

   
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      <br></br>
      </div>
      <div class="modal-body">
      <iframe src='http://pethelp911.com/cms/' style={{width:'100%',height:'500px'}}></iframe>
      </div>
     
    </div>

  </div>
</div> */}
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminDashboard;